<template>
  <div>
    <!--统计行-->
    <ak-model-count-group :options="options" />
    <!--图表行-->
    <ak-model-chart class="m-t-24" title="销售趋势" :options="chartOptions" />
  </div>
</template>
<script>
export default {
  data () {
    return {
      options: [
        {
          model: '_User',
          icon: 'user',
          note: '终端用户',
          where: {
            accountCategory: 'terminalAccount'
          }
        }, {
          model: 'order',
          icon: 'dollar',
          sum: 'orderAmount',
          note: '终端总交易额',
          where: {
            accountCategory: 'terminalAccount',
            status: {
              $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped']
            }
          },
          format: (val) => `${val || 0} 元`
        }, {
          model: '_User',
          icon: 'user',
          note: '代理用户',
          where: {
            accountCategory: 'countyAccount'
          }
        }, {
          model: 'order',
          icon: 'dollar',
          sum: 'orderAmount',
          note: '代理总交易额',
          where: {
            accountCategory: 'countyAccount',
            status: {
              $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped']
            }
          },
          format: (val) => {
            return `${val || 0} 元`
          }
        }
      ],
      chartOptions: [
        {
          model: 'order',
          chartType: 'line',
          sum: 'orderAmount',
          where: {
            accountCategory: 'countyAccount',
            status: {
              $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped']
            }
          },
          name: '代理消费'
        },
        {
          model: 'order',
          chartType: 'line',
          sum: 'orderAmount',
          where: {
            accountCategory: 'terminalAccount',
            status: {
              $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped']
            }
          },
          name: '终端消费'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
</style>
